module.exports = __webpack_public_path__ + "img/vignettes-asso_0003_debra-france.009b081f.jpg";